import useGetProductMediaObjectsData from './useGetProductMediaObjectsData'

export default useGetProductMediaObjectsData
